import { Button } from "./Button";
import { Container } from "./Container";
import { getTranslation } from "dictionary";
import { useUserContext } from "context/UserContext";

export function CallToAction() {
  const { language } = useUserContext();

  return (
    <section
      id="get-started-today"
      className="relative overflow-hidden bg-blue-600 py-32"
    >
      <img
        className="absolute top-1/2 left-1/2 max-w-none -translate-x-1/2 -translate-y-1/2"
        src={"/images/background-call-to-action.jpg"}
        alt="fondo"
        width={1800}
        height={400}
      />
      <Container className="relative">
        <div className="mx-auto max-w-lg text-center">
          <h2 className="font-display text-3xl tracking-tight text-white sm:text-4xl">
            {getTranslation("landingpage", "CALL_ACTION_TITLE", language)}
          </h2>
          <p className="mt-4 text-xl tracking-tight text-white font-light">
            {getTranslation("landingpage", "CALL_ACTION_SUBTITLE", language)}
          </p>
          <Button
            href="/register"
            variant="solidbig"
            color="white"
            className="mt-10"
          >
            {getTranslation("login", "REGISTER", language)}
          </Button>
        </div>
      </Container>
    </section>
  );
}
